/* eslint-disable no-undefined */
import { createRef } from 'preact';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import { ShareButton } from '@playbook/sdk-helpers';

import styleSheet from './styles/prediction.module.scss';

import PollHero from '../../components/Polling/pollHero.component';

const styles = styleSheet.locals || {};

/**
 * Component for the prediction header
 *
 * @param {object} props prediction option props
 * @param {object} props.prediction prediction option data
 * @returns {Function} <PredictionHeader />
 */
function PredictionHeader({ prediction }) {
    const { t } = useTranslation();
    const question = prediction.questions[0];
    const predictionNotOpen =
        prediction.state === 'draft' || prediction.state === 'scheduled';
    const titleRef = createRef();

    return (
        <div className={styles.predictionHeader} part="predictor-header">
            {prediction.hero_image_url && <PollHero poll={prediction} />}

            <div
                part="predictor-status-wrap"
                className={classNames(styles.predictionProductHeader, {
                    [styles.predictionProductHeaderHero]:
                        prediction.hero_image_url
                })}
            >
                {!predictionNotOpen && (
                    <ShareButton
                        pageId={prediction.prediction_id}
                        copiedLabel={t('button.shareCopied')}
                        ariaLabel={t('button.sharePrediction')}
                        partPrefix="predictor-share"
                        onCopied={() => {
                            globalThis.PLAYBOOK_CONFIG?.interactionEvent?.send(
                                'PREDICTION_SHARED'
                            );
                        }}
                    />
                )}
            </div>

            <div
                data-cy="titleLabel"
                part="predictor-question"
                className={styles.predictionQuestion}
                ref={titleRef}
                data-fek-preview="text"
            >
                {question.text}
            </div>
        </div>
    );
}

PredictionHeader.propTypes = {
    prediction: PropTypes.object.isRequired
};

export default PredictionHeader;
